import {
  splitAreas,
  getTitleFontSizeClass,
  tableBrokerageFilter,
} from "./utils";

// =============================================================================
// HARDCODINGS: Table-level disclaimer testing — set any to true to force that disclaimer on.
// =============================================================================
export const TABLE_TEST_DISCLAIMERS = {
  offMarketDisclaimer: false, // keep this
  coListingDiscliamer: false, // keep this
};

/**
 * Title config for rendering: { type, text?, areaSplit?, specialFontSize? }
 */
export function getTitleConfig(hoData, area, demoAccountAreaName) {
  const { changeDetails, subdivisionName, coverPageHeader } = hoData || {};
  const areaSplit = splitAreas(area || "");
  const specialFontSize = getTitleFontSizeClass(areaSplit);

  if (coverPageHeader === "Upper East and Lower Mission Canyon") {
    return {
      type: "coverHeader",
      text: "Lower Mission Canyon and Upper East",
      className: "market-sales-title-text small-market-sales-title",
    };
  }
  if (area === "Winchester Canyon") {
    return {
      type: "winchester",
      text: "Rancho Embarcadero & Winchester",
      className: "market-sales-title-text",
    };
  }
  if (demoAccountAreaName && demoAccountAreaName.length > 1) {
    return {
      type: "demoAccount",
      text: demoAccountAreaName,
      className: "market-sales-title-text",
    };
  }
  if (
    (changeDetails && changeDetails.subdivisionName) ||
    (subdivisionName && subdivisionName.length > 1)
  ) {
    return {
      type: "subdivision",
      text: subdivisionName || changeDetails?.subdivisionName,
      className: "market-sales-title-text",
    };
  }
  return {
    type: "areaSplit",
    areaSplit,
    specialFontSize,
    className: `market-sales-non-sub-container ${specialFontSize}`,
  };
}

/**
 * All customization flags and values derived from props (agent/area-specific)
 */
export function getCustomization(props) {
  const {
    currentArea = {},
    quarterlyAreaTable = {},
    agentData = {},
    miniTableProperties = [],
    currentSoldsLength,
    miniTableDisclaimer1 = null,
    miniTableDisclaimer2 = null,
    miniTableDisclaimer3 = null,
    miniTableDisclaimer4 = null,
    offMarketDisclaimerBool = false,
    coListingDisclaimerBool = false,
    moveQRAndTableDown = false,
    fromThirdPage = false,
  } = props;
  const { mlsAreaID } = currentArea;
  let { listgenUserID, isMemberOfTeam, teamMembers, brokerageName } = agentData;
  if (listgenUserID === "102843") {
    isMemberOfTeam = true;
  }

  // -----------------------------------------------------------------------------
  // HARDCODINGS: Table layout styles (agent/area-specific class names)
  // -----------------------------------------------------------------------------
  const tableStyleClasses = [];
  if (mlsAreaID === "CCA-4500R") {
    tableStyleClasses.push("top-320-mini-table");
  } else if (mlsAreaID === "xCCA-4400QA") {
    tableStyleClasses.push("top-520-mini-table");
  } else if (moveQRAndTableDown) {
    tableStyleClasses.push("top-446-mini-table");
  } else if (fromThirdPage) {
    tableStyleClasses.push("top-405-mini-table");
  } else if (currentSoldsLength != null && currentSoldsLength <= 8) {
    tableStyleClasses.push("move-table-up");
  }

  const tableStyles = tableStyleClasses.join(" ");

  let showRegularDisclaimer = true;
  if (listgenUserID === "107253") showRegularDisclaimer = false;

  let disclaimerStyles;
  if (listgenUserID === "108206") disclaimerStyles = "disclaimer-right-aligned";

  // -----------------------------------------------------------------------------
  // HARDCODINGS: Table-level Special disclaimers & disclaimer-related styles
  // -----------------------------------------------------------------------------
  // Co-listing / off-market footer disclaimers are driven entirely by backend
  // flags on the DTO (mirrors isOffMarketSaleBool). Custom Property Type
  // (disclaimer4) has no backend flag — it shows whenever text is present.
  let coListingDiscliamer = coListingDisclaimerBool === true;
  if (TABLE_TEST_DISCLAIMERS.coListingDiscliamer) coListingDiscliamer = true;

  let offMarketDisclaimer = offMarketDisclaimerBool === true;
  if (TABLE_TEST_DISCLAIMERS.offMarketDisclaimer) offMarketDisclaimer = true;

  // -----------------------------------------------------------------------------
  // Other customization (title, table behavior, brokerage)
  // -----------------------------------------------------------------------------
  let hidePropertyTypeColumn =
    listgenUserID === "109954" || listgenUserID === "100462";

  let marketSalesTitleStyles;
  if (mlsAreaID === "SMA-390")
    marketSalesTitleStyles = "medium-market-sales-title";

  const brokerageDisplayName = tableBrokerageFilter(brokerageName);
  return {
    titleConfig: getTitleConfig(
      props.hoData,
      currentArea?.mlsNeighborhood ||
        currentArea?.areaName ||
        currentArea?.mlsAreaID ||
        "",
      props.demoAccountAreaName,
    ),
    mlsAreaID,
    listgenUserID,
    isMemberOfTeam,
    tableStyles,
    marketSalesTitleStyles,
    hidePropertyTypeColumn,
    offMarketDisclaimer,
    coListingDiscliamer,
    showRegularDisclaimer,
    disclaimerStyles,
    brokerageDisplayName: brokerageDisplayName || brokerageName,
    totalActiveListings: quarterlyAreaTable.totalActiveListings,
    miniTableDisclaimer1,
    miniTableDisclaimer2,
    miniTableDisclaimer3,
    miniTableDisclaimer4,
  };
}
